import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/users/:id',
  title: 'Editar profissional',
  endpoint: '/app/person',
  breadcrumbs: [],
}
